import { FC, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { RaaExpandablePreview, RaaSpinner } from 'raa-react';

import { BebyggelseobjektPubliceradIndex, ModelError, RequestStatus } from 'models';

import { getIconBySkydd } from 'utilities/bebyggelseobjektUtilities';

interface BebyggelseUtkastProps {
  list: Array<BebyggelseobjektPubliceradIndex> | undefined;
  error: ModelError | undefined;
  requestStatus: RequestStatus;
}

const PubliceradeBebyggelseobjekt: FC<BebyggelseUtkastProps> = (props: BebyggelseUtkastProps): ReactElement => {
  return (
    <>
      {props.requestStatus === 'pending' ? (
        <div className="tw-flex tw-justify-center tw-py-8">
          <RaaSpinner size="3rem" />
        </div>
      ) : (
        <>
          {props.error && <p className="tw-py-4 tw-text-raa-error-red">Listan kan inte visas. Ladda om sidan.</p>}
          {!props.error && !props.list?.length && <p className="tw-mt-2">Inga publicerade bebyggelseobjekt.</p>}
          {!props.error && props.list && props.list.length > 0 && (
            <RaaExpandablePreview height={120} ariaLabel="Lista med berörda objekt">
              <ul className="tw-mt-2">
                {Array.from(props.list).map((bebyggelseobjekt: BebyggelseobjektPubliceradIndex) => (
                  <div className="tw-flex tw-items-center tw-justify-between" key={bebyggelseobjekt.id}>
                    <div className="tw-mb-4 tw-flex tw-max-w-[90%] tw-items-center">
                      <img
                        src={`data:image/svg+xml;utf8,${encodeURIComponent(
                          getIconBySkydd(bebyggelseobjekt.skydd.skyddstyp, bebyggelseobjekt.havt_skydd)
                        )}`}
                        alt="Ikon för publicerat bebyggelseobjekt"
                        className="tw-mr-2 tw-h-6"
                      />
                      <li className="tw-flex tw-max-w-[100%] tw-flex-col">
                        <Link className="raa-link tw-font-semibold" to={`/bebyggelseobjekt/${bebyggelseobjekt.id}`}>
                          {bebyggelseobjekt.titel}{' '}
                          <span className="tw-italic">({bebyggelseobjekt.bebyggelsenummer})</span>
                        </Link>
                        <span className="tw-max-w-[100%] tw-truncate tw-capitalize">
                          {bebyggelseobjekt.berorda_fastigheter.join(', ').toLowerCase()}
                        </span>
                      </li>
                    </div>
                  </div>
                ))}
              </ul>
            </RaaExpandablePreview>
          )}
        </>
      )}
    </>
  );
};

export default PubliceradeBebyggelseobjekt;
